import Navbar from "./Navbar";
import LoginPage from "./Login/Login";
import './Css/Login_App.css';

function LoginApp() {
    return (
      <div>
        <Navbar />
        <LoginPage />
      </div>
    );
  }
  
  export default LoginApp;